import { createVanIconComponent } from "./van"

const Add = createVanIconComponent("add")
export default Add
